import BlogComponent from "../components/blogscomponents/blogcomponent"

const BlogPage =()=>{

    return(
        <BlogComponent/>
    )
    
}
export default BlogPage